
import axios from "axios"
import {defineComponent} from 'vue'
import {Locales} from "@/i18n/locales";
import MultiSelect from "primevue/multiselect";


export default defineComponent({
  name: "MultiSelectPicker",
  components: {MultiSelect},
  data() {
    return {
      options: [],
      isActive: false,
      selected: [] as any[],
      limit: 3 // maximum number of selectable items
    }
  },
  props: {
    api: {type: String, required: true},
    name: {type: String, required: true},
    value: {type: Array, required: true},
    clearable: {type: Boolean, required: false, default: true},
    filter: {type: Boolean, required: false, default: true},
  },
  computed: {
    lang(): Locales {
      return this.$store.state.language
    }
  },

  methods: {
    getRequestURI(api: string) {
      // check for additional request params with ? in URI, eg. for api?param=1&lang=de to concatenate URI
      return api.includes('?') ? api + '&lang=' + this.$store.state.language : api + '?lang=' + this.$store.state.language
    },
    getOptions() {
      axios.get(this.getRequestURI(this.api))
          .then(res => this.options = res.data)
    },
    select(value: any) {
      console.log("setting value", value)

      if (value) {
        console.log("setting value", value)
          this.selected = value
      }
      this.$emit('select', {key: this.name, value: this.selected})
    }
  },
  watch: {
    selected() {
      console.log("watch multiselected", this.selected)
    },
    api: {
      handler() {
        this.getOptions()
      },
      immediate: true
    },
    lang() {
      this.getOptions()
    }
  },
  beforeMount() {
    this.selected = this.value
  }
})
